export default __webpack_public_path__ + "svg/calendar/2027/3/mayo.svg?6c8d269f";